<template>
  <div style="padding: 0 16px 16px;">
    <el-tag size="large" type="info" v-for="(item,index) in userList" :key="index" style="margin: 0 8px 8px 0">{{item}}</el-tag>
  </div>
</template>

<script>
import { listAdminNameSysRole } from "@/api/url";
import { getFormData } from "@/api/api";

export default {
name: "RoleUserList",
  props: {
    value: Object
  },
  data() {
    return {
      id: this.value.id,
      userList: [],
    }
  },
  methods: {
    getPage() {
      getFormData(listAdminNameSysRole, {id: this.id}).then(data => {
        let {msg, code} = data
        if (code == 200) {
          this.userList = data.data
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    }
  },
  mounted() {
    this.getPage()
  }
}
</script>

<style scoped>

</style>
